import { req, ydbReq } from '@/utils/request'

//  用户注册服务协议 
export function getAgreementByType (type) {
    return req({ //需要loading加载
        url: `/app/feedback/getAgreement?typeId=${type}`,
        method: 'get'
    })
}

//  有电豹B端公众号授权
export function getMpOpenId (data) {
    return ydbReq({ //需要loading加载
        url: `/obama/ossUser/v1/getOpenID`,
        method: 'post',
        data
    })
}

// 新增代理商
export function addAgent (data) {
    return ydbReq({ //需要loading加载
        url: `/share/register/v1/new/agent`,
        method: 'post',
        data
    })
}

// 获取省市区地址树
export function getAddressTree (data) {
    return ydbReq({
        url: `/lincoln/address/v1/treeLoadAddress/noLogin`,
        method: 'get',
        params: data
    })
}

// 查询证件类型
export function getIdTypeList (data) {
    return ydbReq({
        url: `/obama/group/v1/idTypeEnums/noLogin`,
        method: 'get',
        params: data
    })
}

// 获取强制实名开关
export function getForceRealNameSwitch (data) {
    return ydbReq({
        url: `/stalin/taxReport/v1/queryAuthStatusForXcx/noLogin`,
        method: 'get',
        params: data
    })
}

// 获取实名字段是否必填
export function getForceRealNameRequired (data) {
    return ydbReq({
        url: `/stalin/taxReport/v1/queryAuthStatusRequired/noLogin`,
        method: 'get',
        params: data
    })
}

// 查询负责员工
export function getBelongEmployees (data) {
    return ydbReq({
        url: `/obama/ossUser/v1/query/basicEmployee/page/noLogin`,
        method: 'post',
        params: {
            pageNum: 1,
            pageSize: 50,
            ...data
        }
    })
}

// 上传文件
export function uploadFile (data) {
    return ydbReq({
        url: `/oss/uploadFile`,
        method: 'post',
        data,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
}
